import { createSlice } from '@reduxjs/toolkit'
import { changeTaskAssign, changeTaskStatus, fetchTasks } from './thunks'

const initialState = {
  tasks: [],
  task: {},
  isTasksLoading: false,
  tasksError: undefined,
  tasksTotalElements: 0,
  tasksTotalPages: 0,
  page: 1,
  offset: 10,

  isChangeLoading: false,
  changeStatusError: undefined,
}

const slice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    cleanTasks: (state) => {
      state.tasks = []
    },
    cleanTask: (state) => {
      state.task = []
    },
    setTasksPage: (state, { payload }) => {
      state.page = payload
    },
    setTasksOffset: (state, { payload }) => {
      state.offset = payload
    },
  },
  extraReducers: {
    [fetchTasks.pending]: (state) => {
      state.isTasksLoading = true
    },
    [fetchTasks.fulfilled]: (state, { payload }) => {
      state.isTasksLoading = false
      state.tasksTotalElements = payload.totalElements
      state.tasksTotalPages = payload.totalPages
      if (state.tasks.length) {
        state.tasks = payload.content
          ? [...state.tasks, ...payload.content]
          : []
      } else {
        state.tasks = payload.content ? payload.content : []
      }
    },
    [fetchTasks.rejected]: (state, { error }) => {
      state.isTasksLoading = false
      state.tasksError = error
    },

    [changeTaskStatus.pending]: (state) => {
      state.isChangeLoading = true
    },
    [changeTaskStatus.fulfilled]: (state, { payload }) => {
      state.isChangeLoading = false
      state.tasks = state.tasks.map((task) =>
        task.id === payload.id ? payload : task
      )
    },
    [changeTaskStatus.rejected]: (state, { error }) => {
      state.isChangeLoading = false
      state.changeStatusError = error
    },

    [changeTaskAssign.pending]: (state) => {
      state.isChangeLoading = true
    },
    [changeTaskAssign.fulfilled]: (state, { payload }) => {
      state.isChangeLoading = false
      state.tasks = state.tasks.map((task) =>
        task.id === payload.id ? payload : task
      )
    },
    [changeTaskAssign.rejected]: (state, { error }) => {
      state.isChangeLoading = false
      state.changeStatusError = error
    },
  },
})

export const {
  cleanTasks,
  cleanTask,
  setTasksPage,
  setTasksOffset,
} = slice.actions

export const selectorTasks = (state) => state[slice.name]

export default slice.reducer
